import { SavedFiltersIds } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import { clearSavedFilters } from '../../utils/filters_helpers';
import { changeQueryString, removeFilters } from '../filters/actions';
import { removeAllSavedFilters } from './actions';
import { removeSavedFilter } from './removeSavedFilter';

export const onRemoveAllSavedFilters = (): IThunkActionCreator => (dispatch, getState) => {
  const {
    savedFilters: { items },
  } = getState();
  const locationIdFilter = items.find(({ id }) => id === SavedFiltersIds.Location);
  if (locationIdFilter) {
    dispatch(removeSavedFilter(locationIdFilter));
  }
  const newFilters = clearSavedFilters(getState().filters);
  dispatch(removeAllSavedFilters());
  dispatch(removeFilters(newFilters));
  dispatch(changeQueryString({ ...newFilters, p: 1 }, false, true));
};
